import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { Link } from 'react-router-dom';

export default function CroServices() {
    return (
        <section className="cro-services">
            <Container>
                <div className="section-header cro-reveal">
                    <span className="cro-section-label">What We Do</span>
                    <h2 className="cro-section-title">
                        Three focused services to <span className="highlight">maximize revenue</span>
                    </h2>
                </div>
                <Row>
                    <Col lg={4} md={6} className="mb-4">
                        <div className="cro-service-card cro-reveal cro-delay-1">
                            <div className="service-number">01</div>
                            <h3>Conversion Landing Pages</h3>
                            <p className="service-desc">
                                High-converting landing pages optimized for paid traffic and mobile
                                users. Every pixel is placed with intent.
                            </p>
                            <ul className="cro-service-features">
                                <li>Mobile-first responsive design</li>
                                <li>Fast-loading (&lt; 2s LCP)</li>
                                <li>AI-generated conversion copy</li>
                                <li>Shopify / React / Webflow compatible</li>
                                <li>Heatmap-informed layouts</li>
                            </ul>
                            <Link to="/conversion-landing-pages" style={{ display: 'inline-block', marginTop: '20px', textDecoration: 'underline', color: 'var(--Brand-Primary-bg)', fontWeight: '600', fontSize: '15px' }}>Learn More</Link>
                        </div>
                    </Col>
                    <Col lg={4} md={6} className="mb-4">
                        <div className="cro-service-card cro-reveal cro-delay-2">
                            <div className="service-number">02</div>
                            <h3>CRO Sprints</h3>
                            <p className="service-desc">
                                Rapid, agile optimization cycles designed to identify and fix high-impact
                                conversion bottlenecks in weeks, not months.
                            </p>
                            <ul className="cro-service-features">
                                <li>Rapid 2-4 week execution</li>
                                <li>Immediate UX & UI fixes</li>
                                <li>Agile A/B testing implementation</li>
                                <li>High-impact quick wins</li>
                                <li>Dedicated conversion squad</li>
                            </ul>
                            <Link to="/cro-sprint" style={{ display: 'inline-block', marginTop: '20px', textDecoration: 'underline', color: 'var(--Brand-Primary-bg)', fontWeight: '600', fontSize: '15px' }}>Learn More</Link>
                        </div>
                    </Col>
                    <Col lg={4} md={12} className="mb-4">
                        <div className="cro-service-card cro-reveal cro-delay-3">
                            <div className="service-number">03</div>
                            <h3>Monthly CRO Retainers</h3>
                            <p className="service-desc">
                                Ongoing experimentation and optimization to continuously improve
                                revenue and conversion rates every single month.
                            </p>
                            <ul className="cro-service-features">
                                <li>Continuous A/B testing</li>
                                <li>Variant design &amp; development</li>
                                <li>Monthly reporting &amp; insights</li>
                                <li>Experiment strategy roadmap</li>
                                <li>VWO / Optimizely management</li>
                            </ul>
                            <Link to="/monthly-cro-retainer" style={{ display: 'inline-block', marginTop: '20px', textDecoration: 'underline', color: 'var(--Brand-Primary-bg)', fontWeight: '600', fontSize: '15px' }}>Learn More</Link>
                        </div>
                    </Col>
                </Row>
            </Container>
        </section>
    );
}
